import { i18n } from '@/plugins/i18n'
import { itemStatusVariant, itemStatusStr } from "@/constants/itemStatus";
import itemImage from '../../../assets/media/item.png'



export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: false,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('online-factor.title_item'),
        sortable: false,
        width: 100,
        textAlign: 'center',
    },
    {
        field: 'creator_item',
        title: i18n.t('online-factor.item_creator'),
        template: (row) => {
            return '<span dir="ltr">' + row.user.full_name + '</span>'
        },
        sortable: false,
        width: 100,
        textAlign: 'center',
    },
    {
        field: 'item_code',
        title: i18n.t('online-factor.item_code'),
        template: (row) => {
            if (row.item_code === null ) {
                return '<div>___</div>'
            } else {
                return '<div>' + row.item_code + '</div>'
            }
        },
        sortable: false,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('online-factor.amount'),
        sortable: true,
        width: 100,
        textAlign: 'center',
    },
    {
        field: 'quantity',
        title: i18n.t('online-factor.quantity'),
        template: (row) => {
            let status = quantity_status(row)

            return '<div>' + status + '</div>'
        },
        sortable: true,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'is_archived',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = itemStatusStr.get(row.is_archived)
            let variant = 'badge-' + itemStatusVariant(row.is_archived)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        sortable: false,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'image',
        title: i18n.t('online-factor.image'),
        template: (row) => {
            return image_status(row)
        },
        sortable: false,
        width: 100,
        textAlign: 'center',
    }
]
export const quantity_status = (row) => {
    if (row.is_unlimited == '1')
        return i18n.t('online-factor.unlimited')
    else
        return row.quantity
}
export const image_status = (row) => {
    if (row.image == null) {
        return '<img src=' + itemImage + ' width="30px" />'
    }
    else
        return '<img src="' + row.image + '" width="30px"/>'
}
